<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { type PrimitiveProps } from 'reka-ui';
    import { cva, type VariantProps } from 'class-variance-authority';

    const indicatorVariants = cva(
        'inline-flex items-center justify-center rounded-full transition-all shrink-0 outline-none',
        {
            variants: {
                variant: {
                    default: 'bg-destructive',
                    red: 'bg-destructive',
                    green: 'bg-accent',
                    yellow: 'bg-warning',
                    bright_yellow: 'bg-warning',
                    blue: 'bg-primary',
                    baby_blue: 'bg-primary',
                    transparent: 'bg-transparent border border-foreground',
                },
                size: {
                    default: 'size-3',
                    sm: 'size-2',
                    lg: 'size-4',
                },
            },
            defaultVariants: {
                variant: 'default',
                size: 'default',
            },
        },
    );

    export type IndicatorVariants = VariantProps<typeof indicatorVariants>;

    interface Props extends PrimitiveProps {
        variant?: IndicatorVariants['variant'];
        size?: IndicatorVariants['size'];
        class?: HTMLAttributes['class'];
    }

    const props = defineProps<Props>();
</script>

<template>
    <span :class="cn(indicatorVariants({ variant, size }), props.class)" />
</template>
